import { useEffect } from 'react'

import ReceiptTemplate from 'Components/UI/Templates/Sales/Receipt'

const Receipt = () => {
  useEffect(() => {
    document.title = 'Recibos'
  }, [])

  return <ReceiptTemplate />
}

export default Receipt
